import styled from 'styled-components';
import { Flex } from '@cko/primitives';
export const PageHeader = styled(Flex) `
  margin-bottom: var(--layout-shoe);
`;
